(function () {
  'use strict';

  document.querySelectorAll('[data-storybook-order-preview]').forEach(function (root) {
    var form = root.querySelector('[data-preview-form]');
    var email = root.querySelector('[data-preview-email]');
    var submit = root.querySelector('[data-preview-submit]');
    var status = root.querySelector('[data-preview-status]');
    var intro = root.querySelector('[data-preview-intro]');
    var introDefault = intro ? intro.textContent : '';
    var autoInFlight = false;
    var viewer = root.querySelector('[data-preview-viewer]');
    var gallery = root.querySelector('[data-preview-gallery]');
    var track = root.querySelector('[data-preview-track]');
    var counter = root.querySelector('[data-preview-counter]');
    var prevButton = root.querySelector('[data-preview-prev]');
    var nextButton = root.querySelector('[data-preview-next]');
    var hint = root.querySelector('[data-preview-hint]');
    var documentFrame = root.querySelector('[data-preview-document]');
    var openLink = root.querySelector('[data-preview-open]');
    var title = root.querySelector('[data-preview-title]');
    var pageTitle = root.querySelector('[data-preview-page-title]');
    var viewerHeading = root.querySelector('[data-preview-viewer-heading]');
    var morePanel = root.querySelector('[data-preview-more]');
    var moreName = root.querySelector('[data-preview-more-name]');
    var zoom = root.querySelector('[data-preview-zoom]');
    var zoomImage = root.querySelector('[data-preview-zoom-img]');
    var zoomScroll = root.querySelector('[data-preview-zoom-scroll]');
    var zoomClose = root.querySelector('[data-preview-zoom-close]');
    var zoomReturnTo = null;
    var reference = root.querySelector('[data-preview-reference]');
    var referenceWrap = root.querySelector('[data-preview-reference-wrap]');
    var config = {};
    try {
      config = JSON.parse(root.querySelector('[data-preview-config]').textContent);
    } catch (error) {
      config = {};
    }

    var params = new URLSearchParams(window.location.search);
    var fragmentParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    var preview = (params.get('preview') || '').trim();
    var locator = (fragmentParams.get('key') || '').trim();
    var apiBase = typeof config.apiBaseUrl === 'string'
      ? config.apiBaseUrl.trim().replace(/\/+$/, '')
      : '';

    function showError(message) {
      status.className = 'llsop__status is-error';
      status.textContent = message;
    }

    if (!preview || !locator) {
      form.hidden = true;
      showError('This preview link is incomplete. Please use the link in your order email.');
      return;
    }
    if (!/^https:\/\//i.test(apiBase)) {
      form.hidden = true;
      showError('The secure preview service is temporarily unavailable. Please try again later.');
      return;
    }

    function isTouchDevice() {
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) return true;
      return navigator.maxTouchPoints > 0;
    }

    // Mobile browsers cannot render a PDF inside an iframe, so the primary
    // experience is a swipeable gallery of per-page images fetched with the
    // same HttpOnly session as the PDF. The iframe remains as a fallback for
    // sessions where the page images are unavailable (e.g. older orders).
    function showFrameFallback(documentUrl) {
      gallery.hidden = true;
      documentFrame.hidden = false;
      documentFrame.src = documentUrl + '#view=FitH';
      /* Phone browsers do not render a PDF inside an iframe at all: the frame
         paints as an empty box and the customer is told nothing, even though
         the "Open PDF in a new tab" link directly below it works. Say so,
         reusing the viewer's own hint line (the gallery's swipe hint, which
         this fallback replaces). */
      if (!hint) return;
      if (isTouchDevice()) {
        hint.textContent = 'Tap “Open PDF in a new tab” to view your preview.';
        hint.hidden = false;
      } else {
        hint.hidden = true;
      }
    }

    // Tap-to-enlarge: a phone renders a two-page spread at about 300px wide,
    // far too small to read the story text or see the child's face. The
    // overlay shows the same page image at roughly a page per screen width
    // and scrolls sideways across the spread.
    function closeZoom() {
      if (!zoom || zoom.hidden) return;
      zoom.hidden = true;
      zoomImage.removeAttribute('src');
      document.body.style.overflow = '';
      if (zoomReturnTo && typeof zoomReturnTo.focus === 'function') zoomReturnTo.focus();
      zoomReturnTo = null;
    }
    function openZoom(slide, isCover) {
      if (!zoom || !slide || slide.state !== 'done') return;
      zoomImage.width = slide.img.naturalWidth;
      zoomImage.height = slide.img.naturalHeight;
      zoomImage.src = slide.img.src;
      zoomImage.alt = slide.img.alt;
      zoomImage.className = 'llsop__zoom-img ' + (isCover ? 'llsop__zoom-img--cover' : 'llsop__zoom-img--spread');
      zoomReturnTo = document.activeElement;
      zoom.hidden = false;
      document.body.style.overflow = 'hidden';
      zoomScroll.scrollLeft = 0;
      zoomClose.focus();
    }
    if (zoom) {
      zoomClose.addEventListener('click', closeZoom);
      zoom.addEventListener('click', function (event) {
        if (event.target === zoom || event.target === zoomScroll) closeZoom();
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeZoom();
      });
    }

    var coverPreview = false;
    // The whole-book preview: the front cover, then every inside spread.
    var wholeBookPreview = false;
    // Above 900px the CSS gives the stage one viewport-derived height for
    // every page (the pages fit inside it), so the track must not carry an
    // inline height from the phone's image-height behaviour.
    var stageOwnedByCss = window.matchMedia('(min-width: 900px)');
    function setupGallery(documentUrl, pageCount, coloring) {
      var pagesBase = documentUrl.replace(/\/document$/, '/pages/');
      var storyPageCount = pageCount;
      if (coloring) pageCount += coloring.page_image_count;
      var slides = [];
      var current = 0;

      track.innerHTML = '';
      for (var i = 0; i < pageCount; i++) {
        var isColoring = i >= storyPageCount;
        var coloringPage = i - storyPageCount;
        var portrait = isColoring || ((coverPreview || wholeBookPreview) && i === 0);
        var slide = document.createElement('div');
        slide.className = 'llsop__slide' + (portrait ? ' llsop__slide--cover' : '');
        var img = document.createElement('img');
        img.className = 'llsop__page';
        img.alt = coverPreview ? (i === 0 ? 'Personalised book cover' : 'Story pages ' + (i * 2 - 1) + '–' + (i * 2))
          : wholeBookPreview ? (i === 0 ? 'Personalised book cover' : 'Book spread ' + i + ' of ' + (storyPageCount - 1))
          : 'Book preview, page ' + (i + 1) + ' of ' + pageCount;
        if (isColoring) img.alt = coloringPage === 0 ? config.coloringCover : config.coloringPage + ' ' + coloringPage + ' / 5';
        img.draggable = false;
        slide.appendChild(img);
        track.appendChild(slide);
        slides.push({ el: slide, img: img, state: 'idle', portrait: portrait,
          url: isColoring ? coloring.document_url.replace(/\/document$/, '/pages/') + (coloringPage + 1) : pagesBase + (i + 1) });
        (function (index) {
          slide.addEventListener('click', function () {
            openZoom(slides[index], slides[index].portrait);
          });
        }(i));
      }

      // The slides no longer sit in a fixed-height box (a phone got a
      // 240px stage), so the track follows the height of the page in view:
      // a portrait cover and a landscape spread differ by 2x.
      function fitTrack() {
        if (stageOwnedByCss.matches) { track.style.height = ''; return; }
        var slide = slides[current];
        if (!slide || slide.state !== 'done') return;
        var height = slide.img.getBoundingClientRect().height;
        if (height > 0) track.style.height = Math.round(height) + 'px';
      }

      function loadPage(index) {
        var slide = slides[index];
        if (!slide || slide.state === 'loading' || slide.state === 'done') return;
        slide.state = 'loading';
        fetch(slide.url, {
          credentials: 'include',
          referrerPolicy: 'no-referrer'
        }).then(function (response) {
          if (!response.ok) throw new Error('page');
          return response.blob();
        }).then(function (blob) {
          slide.img.src = URL.createObjectURL(blob);
          slide.state = 'done';
          slide.el.classList.add('is-loaded');
          slide.img.addEventListener('load', function () { if (index === current) fitTrack(); }, { once: true });
          if (index === current) fitTrack();
        }).catch(function () {
          slide.state = 'failed';
          if (index === 0) {
            // The very first page could not load: fall back to the PDF frame.
            showFrameFallback(documentUrl);
          } else if (index >= storyPageCount) {
            slide.el.textContent = 'This colouring preview page could not load. Reopen your secure link to try again.';
            slide.el.setAttribute('role', 'status');
          }
        });
      }

      function sync(index) {
        var width = track.clientWidth || 1;
        if (typeof index !== 'number') index = Math.round(track.scrollLeft / width);
        current = Math.max(0, Math.min(pageCount - 1, index));
        counter.textContent = coverPreview ? (current === 0 ? 'Cover' : 'Story pages ' + (current * 2 - 1) + '–' + (current * 2) + ' · Spread ' + current + ' of 5')
          : wholeBookPreview ? (current === 0 ? 'Cover' : 'Spread ' + current + ' of ' + (storyPageCount - 1))
          : (current + 1) + ' / ' + pageCount;
        if (coloring && current >= storyPageCount) counter.textContent = current === storyPageCount ? config.coloringCover : config.coloringPage + ' ' + (current - storyPageCount) + ' / 5';
        prevButton.disabled = current === 0;
        nextButton.disabled = current === pageCount - 1;
        for (var i = current - 2; i <= current + 2; i++) {
          if (i >= 0 && i < pageCount) loadPage(i);
        }
        fitTrack();
      }

      function goTo(index) {
        sync(index);
        var target = Math.round(current * track.clientWidth);
        var from = track.scrollLeft;
        try {
          track.scrollTo({ left: target, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        } catch (error) {
          track.scrollLeft = target;
          return;
        }
        // Engines that ignore smooth programmatic scrolling on a snap
        // container still get the page turn, just without the glide.
        window.setTimeout(function () {
          if (track.scrollLeft === from && from !== target) track.scrollLeft = target;
        }, 250);
      }

      var scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) return;
        scrollTimer = window.setTimeout(function () {
          scrollTimer = null;
          sync();
        }, 80);
      });
      window.addEventListener('resize', function () {
        track.scrollLeft = current * track.clientWidth;
        fitTrack();
      });
      prevButton.addEventListener('click', function () { goTo(current - 1); });
      nextButton.addEventListener('click', function () { goTo(current + 1); });
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
      });

      gallery.classList.toggle("is-cover-preview", coverPreview || wholeBookPreview);
      // Touch screens swipe; the overlay arrows only cover the artwork there.
      gallery.classList.toggle('is-touch', isTouchDevice());
      gallery.hidden = false;
      documentFrame.hidden = true;
      hint.textContent = isTouchDevice()
        ? 'Swipe to turn the pages. Tap a page to enlarge it.'
        : 'Use the arrows to turn the pages. Click a page to enlarge it.';
      hint.hidden = false;
      sync();
    }

    var reviewPanel = root.querySelector('[data-review-panel]');
    var reviewStatus = root.querySelector('[data-review-status]');
    var cancelButton = root.querySelector('[data-review-cancel]');
    var cancelWrap = root.querySelector('[data-review-cancel-wrap]');
    var qualityNote = root.querySelector('[data-review-quality]');
    var confirmPanel = root.querySelector('[data-review-confirm]');
    var confirmButton = root.querySelector('[data-review-confirm-cancel]');
    var reviewUrl = apiBase + '/storybook/order-previews/' + encodeURIComponent(preview);
    var reviewTimer;
    function renderReview(result) {
      if (!reviewPanel || !result) return;
      reviewPanel.hidden = false;
      var confirming = !confirmPanel.hidden;
      if (cancelWrap) cancelWrap.hidden = !result.can_cancel || confirming;
      else cancelButton.hidden = !result.can_cancel;
      if (qualityNote) qualityNote.hidden = !result.can_cancel;
      if (!result.can_cancel) confirmPanel.hidden = true;
      var deadline = result.deadline ? new Date(result.deadline).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : '';
      if (result.status === 'cancelled') {
        reviewStatus.textContent = 'Your order is cancelled. Check your cancellation email for refund details.';
      } else if (/^cancel/.test(result.status)) {
        reviewStatus.textContent = 'Your cancellation has been received and production is on hold. We are confirming the cancellation and refund. You do not need to submit again.';
      } else if (!result.can_cancel) {
        reviewStatus.textContent = 'The cancellation window has closed. Your order is now eligible for production.';
      } else if (deadline) {
        reviewStatus.textContent = 'Your order goes to print after ' + deadline + ' (your local time). If you’re happy with it, there’s nothing more to do.';
      } else {
        reviewStatus.textContent = 'Your order goes to print 24 hours after the final book preview email. If you’re happy with it, there’s nothing more to do.';
      }
    }
    function refreshReview() {
      fetch(reviewUrl + '/review', { credentials: 'include', referrerPolicy: 'no-referrer' }).then(function (response) {
        if (!response.ok) throw new Error('session');
        return response.json();
      }).then(renderReview).catch(function () {
        if (cancelWrap) cancelWrap.hidden = true;
        cancelButton.hidden = true;
        confirmPanel.hidden = true;
        reviewStatus.textContent = 'Please reopen the preview link and verify your email to check the deadline or cancel. If this service is unavailable, contact support@labelandleaf.com before your deadline.';
        window.clearInterval(reviewTimer);
      });
    }
    if (cancelButton) {
      cancelButton.addEventListener('click', function () {
        if (cancelWrap) cancelWrap.hidden = true;
        confirmPanel.hidden = false;
        root.querySelector('[data-review-confirm-title]').focus();
      });
      root.querySelector('[data-review-keep]').addEventListener('click', function () {
        confirmPanel.hidden = true;
        if (cancelWrap) cancelWrap.hidden = false;
        cancelButton.focus();
      });
      confirmButton.addEventListener('click', function () {
        confirmButton.disabled = true;
        reviewStatus.textContent = 'Submitting your cancellation…';
        fetch(reviewUrl + '/cancel', {
          method: 'POST', credentials: 'include', referrerPolicy: 'no-referrer',
          headers: { 'Content-Type': 'application/json', 'X-Review-Action': 'cancel-order' }, body: '{}'
        }).then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.detail || 'Cancellation could not be confirmed. Please try again.');
            return body;
          });
        }).then(function (body) {
          confirmPanel.hidden = true;
          renderReview(body);
        }).catch(function (error) {
          reviewStatus.textContent = error.message || 'We could not confirm the response. Check the order status or try again; repeated requests are safe.';
        }).finally(function () { confirmButton.disabled = false; });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!email.checkValidity()) {
        email.reportValidity();
        return;
      }
      submit.disabled = true;
      submit.textContent = 'Checking…';
      status.className = 'llsop__status';
      status.textContent = 'Verifying your order securely…';

      fetch(apiBase + '/storybook/order-previews/verify', {
        method: 'POST',
        credentials: 'include',
        referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ preview: preview, key: locator, email: email.value })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) throw new Error(body.detail || 'Those details do not match this order.');
          return body;
        });
      }).then(function (result) {
        form.hidden = true;
        if (intro) intro.hidden = true;
        root.classList.add('is-open');
        status.className = 'llsop__status';
        status.textContent = '';
        coverPreview = result.content_kind === 'cover_story_spreads';
        wholeBookPreview = result.content_kind === 'cover_all_pages';
        if (result.review) {
          renderReview(result.review);
          window.clearInterval(reviewTimer);
          reviewTimer = window.setInterval(refreshReview, 30000);
        }
        var posePreview = result.content_kind === 'character_poses';
        var previewLabel = posePreview ? 'character preview' : 'book';
        title.textContent = (result.child_name ? result.child_name + '’s ' + previewLabel : result.order_name) || 'Your preview';
        // One heading, then the book: the child's title replaces the
        // generic H1 and the duplicate viewer heading is hidden.
        if (pageTitle && viewerHeading) {
          pageTitle.textContent = title.textContent;
          viewerHeading.hidden = true;
        }
        if (morePanel) {
          if (moreName && result.child_name) moreName.textContent = result.child_name;
          // Don't offer the customer the book they are previewing.
          if (result.story_id) {
            morePanel.querySelectorAll('[data-story-id]').forEach(function (item) {
              if (item.getAttribute('data-story-id') === result.story_id) item.hidden = true;
            });
          }
          // A row with every card filtered out disappears, and a panel with
          // nothing left to offer (collections not configured on the page
          // template, or no cards for this region) stays hidden rather than
          // showing an empty "More keepsakes" heading.
          var visibleRows = 0;
          morePanel.querySelectorAll('[data-preview-more-row]').forEach(function (row) {
            var cards = row.querySelectorAll('[data-story-id]:not([hidden])').length;
            row.hidden = cards === 0;
            if (cards > 0) visibleRows += 1;
          });
          morePanel.hidden = visibleRows === 0;
        }
        if (result.order_name) {
          reference.textContent = result.order_name;
          referenceWrap.hidden = false;
        }
        openLink.href = result.document_url;
        var bonusPanel = root.querySelector('[data-preview-bonus]');
        var bonusLinks = result.printable_bonus;
        if (bonusPanel && bonusLinks) {
          var expectedBase = apiBase + '/storybook/order-previews/' + encodeURIComponent(preview) + '/printable/';
          if (bonusLinks.a4 === expectedBase + 'a4' && bonusLinks.letter === expectedBase + 'letter') {
            root.querySelector('[data-preview-bonus-a4]').href = bonusLinks.a4;
            root.querySelector('[data-preview-bonus-letter]').href = bonusLinks.letter;
            bonusPanel.hidden = false;
          }
        }
        var pageCount = parseInt(result.page_image_count, 10) || 0;
        var coloring = result.coloring_preview;
        var coloringPanel = root.querySelector('[data-preview-coloring]');
        var coloringUrl = apiBase + '/storybook/order-previews/' + encodeURIComponent(preview) + '/coloring/document';
        if (!coloring || coloring.document_url !== coloringUrl || coloring.page_image_count !== 6) coloring = null;
        // Their Complete Collection shows Book 1 alone and has no colouring
        // book: say so, and never show the Read & Colour wording beside it.
        var collectionNote = root.querySelector('[data-preview-collection]');
        var isCollection = result.bundle_id === 'complete-collection';
        if (isCollection) coloring = null;
        if (collectionNote && isCollection) collectionNote.hidden = false;
        if (coloringPanel && coloring) {
          root.querySelector('[data-preview-coloring-open]').href = coloringUrl;
          coloringPanel.hidden = false;
        }
        if (pageCount > 0) {
          setupGallery(result.document_url, pageCount, coloring);
        } else {
          showFrameFallback(result.document_url);
        }
        viewer.hidden = false;
        if (window.history && window.history.replaceState) {
          /* The one-time locator lives ONLY in the fragment, so it never
             reaches a server log — which also means dropping it here left the
             address bar holding a link that cannot be opened again: a refresh,
             or a Back into this page, reloaded the "This preview link is
             incomplete" error over the preview just unlocked. Keep the
             fragment exactly as it arrived (rebuilding it from the locator
             only if some earlier navigation already cleared it). */
          var keptHash = window.location.hash || ('#key=' + encodeURIComponent(locator));
          window.history.replaceState(null, '', window.location.pathname + '?preview=' + encodeURIComponent(preview) + keptHash);
        }
        // Scroll to the book only when it is not already in view: on a
        // desktop the compact header leaves it at the top of the page, and
        // scrolling to something the customer can already see is its own jolt.
        var viewerTop = viewer.getBoundingClientRect().top;
        var headerClearance = 110;
        if (viewerTop < headerClearance || viewerTop > window.innerHeight * 0.5) {
          viewer.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }).catch(function (error) {
        if (autoInFlight && intro) {
          // The signed-in email didn't match this order's checkout email:
          // bring back the manual instructions with the form still prefilled.
          intro.textContent = introDefault;
          form.hidden = false;
        }
        showError(error && error.message ? error.message : 'Those details do not match this order.');
      }).finally(function () {
        autoInFlight = false;
        submit.disabled = false;
        submit.textContent = 'Open my book';
      });
    });

    // Logged-in customers arriving from the My Books hub: skip the typing.
    // The submit handler above is already attached; on failure the catch
    // restores the manual instructions with the form prefilled as fallback.
    var autoEmail = typeof config.customerEmail === 'string' ? config.customerEmail.trim() : '';
    if (autoEmail) {
      email.value = autoEmail;
      autoInFlight = true;
      if (intro) intro.textContent = 'One moment — opening your book…';
      form.hidden = true;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    }
  });
}());
